import React, { useEffect, useState } from "react";
import { apiWrapper } from "../../apis/CommonApi";
import * as mobileApi from "../../apis/MobileApi";
import { useParams } from "react-router-dom";
import { useAppContext } from "../../utils/store";
import PageHeader from "../PageHeader";

export default function FireAlarmSmsSettingComponent() {
  const { id } = useParams();
  const { store: { id: userId } } = useAppContext();
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    setFormDataProperty("mdetectorOperation", false);
    setFormDataProperty("maccumulatedOperation", false);
    setFormDataProperty("mtransmitterOperation", false);
    setFormDataProperty("mequipmentOutputOperation", false);
    setFormDataProperty("mpowerFaultAlarm", false);
    setFormDataProperty("mcontrolOperation", false);

    apiWrapper(async () => {
      const { status, data } = await mobileApi.getFireFightingObjectMobileAlarmSetting(userId);
      if (status === true) {
        setFormDataProperty("mdetectorOperation", data.mdetectorOperation);
        setFormDataProperty("maccumulatedOperation", data.maccumulatedOperation);
        setFormDataProperty("mtransmitterOperation", data.mtransmitterOperation);
        setFormDataProperty("mequipmentOutputOperation", data.mequipmentOutputOperation);
        setFormDataProperty("mpowerFaultAlarm", data.mpowerFaultAlarm);
        setFormDataProperty("mcontrolOperation", data.mcontrolOperation);
      } else {
        alert(`${data}`);
      }
    });
  }, []);

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.checked;
    setFormDataProperty(name, value);

    apiWrapper(async () => {
      const requestBody = {
        "mdetectorOperation": name === "mdetectorOperation" ? value : formData.mdetectorOperation,
        "maccumulatedOperation": name === "maccumulatedOperation" ? value : formData.maccumulatedOperation,
        "mtransmitterOperation": name === "mtransmitterOperation" ? value : formData.mtransmitterOperation,
        "mequipmentOutputOperation": name === "mequipmentOutputOperation" ? value : formData.mequipmentOutputOperation,
        "mpowerFaultAlarm": name === "mpowerFaultAlarm" ? value : formData.mpowerFaultAlarm,
        "mcontrolOperation": name === "mcontrolOperation" ? value : formData.mcontrolOperation
      }

      const { status, data } = await mobileApi.updateFireFightingObjectMobileAlarmSetting(userId, requestBody);
      if (status === false) {
        alert(`${data}`);
      }
    });
  };

  return (
    <section class="mbSection">
      <PageHeader isBlack={false} title="화재경보 SMS 설정" isUseMenu={false} />
      <div class="container pb-per">
        <div class="tableList fireSMSlist">
          <div class="config-row title-row">
            <div class="title-txt config-title">상태</div>
            <div class="title-txt config-switch">OFF/ON</div>
          </div>
          {formData && (
            <>
              <div class="config-row">
                <div class="config-title">화재 입력회로 감지기 동작 발생</div>
                <div class="config-switch">
                  <label class="switch">
                    <input type="checkbox" name="mdetectorOperation" checked={formData.mdetectorOperation} onChange={onChange} />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
              <div class="config-row">
                <div class="config-title">화재 입력회로 축적 동작 발생</div>
                <div class="config-switch">
                  <label class="switch">
                    <input type="checkbox" name="maccumulatedOperation" checked={formData.maccumulatedOperation} onChange={onChange} />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
              <div class="config-row">
                <div class="config-title">화재 입력회로 발신기 동작 발생</div>
                <div class="config-switch">
                  <label class="switch">
                    <input type="checkbox" name="mtransmitterOperation" checked={formData.mtransmitterOperation} onChange={onChange} />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
              <div class="config-row">
                <div class="config-title">설비 출력회로 동작 발생</div>
                <div class="config-switch">
                  <label class="switch">
                    <input type="checkbox" name="mequipmentOutputOperation" checked={formData.mequipmentOutputOperation} onChange={onChange} />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
              <div class="config-row">
                <div class="config-title">화재수신기 전원/고장 알람 발생</div>
                <div class="config-switch">
                  <label class="switch">
                    <input type="checkbox" name="mpowerFaultAlarm" checked={formData.mpowerFaultAlarm} onChange={onChange} />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
              <div class="config-row">
                <div class="config-title">화재수신기 제어 동작 발생</div>
                <div class="config-switch">
                  <label class="switch">
                    <input type="checkbox" name="mcontrolOperation" checked={formData.mcontrolOperation} onChange={onChange} />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div class="btmBtnWrap">
        <button class="btn btn-grey">취소</button>
        <button class="btn btn-black">저장</button>
      </div>
    </section>
  );
}
